import { LegalDocumentPage } from "components/LegalDocumentPage";
import {
  termsOfServiceIntro,
  termsOfServiceMeta,
  termsOfServiceSections,
} from "content/termsOfServiceContent";

export default function TermsOfServicePage() {
  return (
    <LegalDocumentPage
      meta={termsOfServiceMeta}
      intro={termsOfServiceIntro}
      sections={termsOfServiceSections}
      helmetDescription="Fortify Portal, Inc. Terms of Use — rules for accessing and using the Fortify start-up crowdfunding platform."
    />
  );
}
